import { useEffect, useState } from "react";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export function useObservations(id, category = "") {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarObservaciones.php", {
      token: userData.token,
      optica: selectedOptic.id,
      id: id,
      categoria: category,
    });
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [id, category]);

  return { list, refresh: getData };
}
